"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE_OWNERSHIP = void 0;
const roles_1 = require("./roles");
const routes_1 = require("./routes");
exports.ROUTE_OWNERSHIP = [
    { prefix: '/static/modern', owner: 'admin-modern', area: 'assets' },
    { prefix: '/static/legacy', owner: 'legacy-admin', area: 'assets' },
    { prefix: '/vendors', owner: 'legacy-admin', area: roles_1.AREAS.VENDORS },
    { prefix: '/promo-codes', owner: 'legacy-admin', area: roles_1.AREAS.PROMO_CODES },
    { prefix: routes_1.ROUTES.RULES, owner: 'legacy-admin', area: roles_1.AREAS.RULES },
    { prefix: routes_1.ROUTES.MODERN_RULES, owner: 'admin-modern', area: roles_1.AREAS.RULES },
    { prefix: routes_1.ROUTES.KNOWLEDGE_BASE, owner: 'admin-modern', area: roles_1.AREAS.KNOWLEDGE_BASE },
    { prefix: routes_1.ROUTES.PROJECT_TIMELINES, owner: 'admin-modern', area: roles_1.AREAS.PROJECT_PLANNING },
    { prefix: routes_1.ROUTES.MODERN_HOME, owner: 'admin-modern', area: 'platform' },
    { prefix: '/cms', owner: 'legacy-admin', area: roles_1.AREAS.CMS },
    { prefix: '/access-denied', owner: 'legacy-admin', area: 'platform' },
    { prefix: '/authorize', owner: 'legacy-admin', area: 'platform' },
    { prefix: '/', owner: 'legacy-admin', area: 'platform' },
];
